import React from "react";

import AccountTable from "../../components/snapshotdatamanagement/AccountTable";



function ProviderAccountsTable(props) {
  return (
    <div className="provider-accounts-table" style={providerAccountsTable}>
      
            {
              props.data.map((providerAccount) => (
                <React.Fragment>
                  <div className="provider-account" style={tableHeader}>
                    
                  {providerAccount.providerName} <span style={providerAccountId}>(Provider Account ID: {providerAccount.providerAccountId})</span>
                   
                  </div>
                      <AccountTable data={providerAccount.accounts} />
                    
                </React.Fragment>
              ))
            }
           
    </div>
  )
}

const providerAccountsTable = {
  padding:'0px',
  border:'1px solid #cdcac9'
}

const providerAccountId = {
  fontSize: '0.75rem'
}

const tableHeader = {
	background:'#eeefee'
}

export default ProviderAccountsTable;

